import type { FC } from 'react';
import { InputGroup } from '@patternfly/react-core/dist/dynamic/components/InputGroup';
import { TextInput } from '@patternfly/react-core/dist/dynamic/components/TextInput';
import { TextArea } from '@patternfly/react-core/dist/dynamic/components/TextArea';
import { InputGroupItem } from '@patternfly/react-core/dist/dynamic/components/InputGroup';
import BaseInputField from './BaseInputField';
import type { GroupInputProps } from './field-types';
import { GroupTextType } from './field-types';

const InputGroupField: FC<GroupInputProps> = ({
  beforeInput,
  afterInput,
  groupTextType,
  ...baseProps
}) => {
  return (
    <BaseInputField {...baseProps}>
      {(props) => {
        return (
          <InputGroup>
            <InputGroupItem>{beforeInput}</InputGroupItem>
            <InputGroupItem>
              {groupTextType === GroupTextType.TextArea ? (
                <TextArea {...props} />
              ) : (
                <TextInput {...props} />
              )}
            </InputGroupItem>
            {afterInput}
          </InputGroup>
        );
      }}
    </BaseInputField>
  );
};

export default InputGroupField;
